import { CerFormAdapter } from '@cer/cer-form/cer-form-adapter';
import { CerFormView } from '@cer/cer-form/cer-form-view';
import { FieldWidthEnum } from 'src/cer/cer-data/cer-data-types';

export class VoucherMessageChannelForm extends CerFormAdapter {
  public override view(): CerFormView {
    return new CerFormView({
      viewMetadata: {
      name: 'mailkanaler', dataApiName: 'VoucherMessageChannel', text: 'Mail indgående kanaler', textSingular: 'Kanal',
      primaryKey: 'id', baseFields: ['id', 'name', 'history']
    },
    fieldMetadata: [
        { name: 'type', text: 'Type', tooltipText: 'Type af kanal', required: true, foreignKeyTableName: 'VoucherMessageChannelType' },
        { name: 'formRecognizer', text: 'Fast dokument genkendelse', tooltipText: 'Anvendes til altid til ', foreignKeyTableName: 'FormRecognizer' },
        { name: 'voucherStatus', text: 'Bilagsstatus', tooltipText: 'Standard bilagsstatus for bilag', allowEdit: true, widthType: FieldWidthEnum.M, foreignKeyTableName: 'VoucherApprovalStatus' },
        { name: 'ledgerJournalName', text: 'Finanskladde', tooltipText: 'Finanskladde som bilag placeres i', foreignKeyTableName: 'FinanceLedgerJournalName', foreignKeyField: 'num' }
      ]
    });
  }
}
